import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { Invitor } from './types';

interface InvitorState {
  invitor: Invitor | null;
  hasLoaded: boolean;
}

const initialState: InvitorState = {
  invitor: null,
  hasLoaded: false,
};

const invitorSlice = createAppSlice({
  name: 'invitor',
  initialState,
  reducers: {
    setInvitor: (state, action: PayloadAction<Invitor | null>) => {
      state.invitor = action.payload;
      state.hasLoaded = true;
    },
    invitorReset: () => initialState,
  },
});

export const { setInvitor, invitorReset } = invitorSlice.actions;
export default invitorSlice.reducer;
